import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=59aed51d"
import script from "./photos.vue?vue&type=script&lang=js"
export * from "./photos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports